import React, { useEffect, useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import CusCheckbox from '../../../../../components/material-ui/CusCheckbox';
import ReverseSwitch from '../../../../../components/material-ui/ReverseSwitch';
import FlexContainer from '../../../../../components/material-ui/adaptive/FlexContainer';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';
import ShowContainer from '../../../../../components/material-ui/ShowContainer';
import { Trans, useTranslation } from 'react-i18next';
import CusLink from '../../../../../components/material-ui/CusLink';
import imgBotStep1 from './bot-step-1.png';
import imgBotStep2 from './bot-step-2.png';
import TypographyText from '../../../../../components/material-ui/table/TypographyText';
import { API_CASINO } from '../../../../../api/casino';
import useToast from '../../../../../hooks/useToast';
import LoaderContainer from '../../../../../components/material-ui/loader_container/LoaderContainer';
import CusTooltip from '../../../../../components/material-ui/CusTooltip';
import GoogleAuth from './GoogleAuth';

export default function CasinoAuthContent({ casino }) {
  const { t } = useTranslation();
  const { isMobile } = useBootstrapSize();
  const { successToast } = useToast();

  const defaultDomain = casino?.domain;
  const casinoId = casino?.id;

  const [isEmail, setIsEmail] = useState(false);
  const [verifyInfo, setVerifyInfo] = useState({});
  const [isTgWeb, setIsTgWeb] = useState(false);
  const [isPhone, setIsPhone] = useState(false);
  const [loader, setLoader] = useState(true);

  const updateParamCasino = (param) => {
    API_CASINO.auth
      .set({ casinoId, ...param })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  useEffect(() => {
    if (!casinoId) return;
    setLoader(true);
    API_CASINO.auth
      .get({ casinoId })
      .then((e) => {
        const data = e.data.data;
        setIsEmail(data.emailRegEnabled);
        setIsTgWeb(data.tgRegEnabled);
        setIsPhone(data.phoneRegEnabled);
        setVerifyInfo(data.emailVerifyRequire);
      })
      .catch(console.error)
      .finally(() => setLoader(false));
  }, [casinoId]);

  return (
    <LoaderContainer loader={loader} isBox boxSx={{ height: '540px' }}>
      <Stack gap={2}>
        <Stack gap={0.5}>
          <GoogleAuth updateParamCasino={updateParamCasino} />
          <ReverseSwitch
            label={'Via email'}
            checked={isEmail}
            onChange={() => {
              setIsEmail((prev) => !prev);
              updateParamCasino({ emailRegEnabled: !isEmail });
            }}
          />

          <Stack gap={0.5}>
            <Stack gap={0.5} direction={'row'}>
              <Typography>{t('Require verification when')}</Typography>
              <CusTooltip
                text={
                  'Until their email address is verified, the player is prohibited from: topping up their balance, withdrawing funds from their balance, and activating promo codes.'
                }
              />
            </Stack>

            <Stack direction={'row'} gap={1}>
              <CusCheckbox
                label="Top up balance"
                checked={verifyInfo.deposit}
                onChange={() => {
                  const newVerify = { ...verifyInfo, deposit: !verifyInfo.deposit };

                  setVerifyInfo(newVerify);
                  updateParamCasino({ emailVerifyRequire: newVerify });
                }}
              />

              <CusCheckbox
                label="Withdrawal from balance"
                checked={verifyInfo.payout}
                onChange={() => {
                  const newVerify = { ...verifyInfo, payout: !verifyInfo.payout };

                  setVerifyInfo(newVerify);
                  updateParamCasino({ emailVerifyRequire: newVerify });
                }}
              />

              <CusCheckbox
                label="Promo Code Activation"
                checked={verifyInfo.promocode}
                onChange={() => {
                  const newVerify = { ...verifyInfo, promocode: !verifyInfo.promocode };

                  setVerifyInfo(newVerify);
                  updateParamCasino({ emailVerifyRequire: newVerify });
                }}
              />
            </Stack>
          </Stack>
        </Stack>

        <ReverseSwitch
          label={'Via phone number'}
          checked={isPhone}
          onChange={() => {
            setIsPhone((prev) => !prev);
            updateParamCasino({ phoneRegEnabled: !isPhone });
          }}
        />

        <Stack gap={0.5}>
          <ReverseSwitch
            label={'Via Telegram Web Login'}
            checked={isTgWeb}
            onChange={() => {
              setIsTgWeb((prev) => !prev);
              updateParamCasino({ tgRegEnabled: !isTgWeb });
            }}
          />
          <ShowContainer condition={isTgWeb}>
            <Stack gap={0.5}>
              <Typography component={'span'}>
                {t('Domain (default)')}:{' '}
                <TypographyText fontSize={14} isCopy={defaultDomain} sx={{ py: 0, px: 0.5 }}>
                  {defaultDomain}
                </TypographyText>{' '}
                <Trans
                  i18nKey="please_mention_with_link"
                  components={{
                    bold: <b key="bold" />,
                    link: (
                      <CusLink
                        key="link"
                        text="@BotFather"
                        linkComponent="a"
                        target="_blank"
                        href="https://t.me/BotFather"
                      />
                    )
                  }}
                />
                {t(', otherwise authorization via Telegram will not work on the site.')}
              </Typography>

              <Stack direction={'row'} gap={0.5}>
                <Box width="300px">
                  <img src={imgBotStep1} width={'100%'} />
                </Box>
                <Box width="300px">
                  <img src={imgBotStep2} width={'100%'} />
                </Box>
              </Stack>
            </Stack>
          </ShowContainer>
        </Stack>
      </Stack>
    </LoaderContainer>
  );
}
